module.exports = __webpack_public_path__ + "img/brand7.d6db25a7.png";